import { Component, Element, h, Host, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent, VirtualPageTrackingEvent } from '@union-investment/tracking/src/events';
import { defaultTrackingParameter } from '../../global/utility/tracking-helpers';
import { TrackingInformation } from '../../types/global';
import { isMagnoliaEditingMode } from '../../helper';

interface UiCmsTabBody {
  active?: boolean;
  anchorName?: string;
  name: string;
}

@Component({
  tag: 'ui-cms-tab',
  styleUrls: { default: 'ui-cms-tab.scss', editing: 'ui-cms-tab.magnolia.scss' },
})
export class UiCmsTab {
  @Element() el: HTMLUiCmsTabElement;

  @Prop({ mutable: true }) body: UiCmsTabBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) tracking: TrackingInformation = defaultTrackingParameter;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  private handleTracking(): void {
    const actionTrackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: `Click Tab ${this.body.name}`,
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: this.body.name,
        target: window.location.href,
      },
      category: {
        area: 'Content',
      },
    };

    const virtualPageTrackingEvent: VirtualPageTrackingEvent = {
      eventInfo: {
        eventName: `Click Tab ${this.body.name}`,
        eventType: 'VirtualPage',
      },
      attributes: {
        virtualContentGroups: [this.body.name],
      },
    };
    window.ui.services.tracking.track(actionTrackingEvent);
    window.ui.services.tracking.track(virtualPageTrackingEvent);
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
    if (isMagnoliaEditingMode()) this.body.active = true;
  }

  render() {
    return (
      <Host>
        <sd-tab onClick={() => this.handleTracking()} slot="nav" panel={this.body.name} active={this.body?.active}>
          {this.body?.name}
        </sd-tab>
        <sd-tab-panel name={this.body?.name} active={this.body?.active}>
          {this.body.anchorName && <ui-cms-anchor id={this.body.anchorName}></ui-cms-anchor>}
          <slot></slot>
        </sd-tab-panel>
      </Host>
    );
  }
}
